/*******************************************************************************
 * constants.js - Element IDs, Storage Keys, and API Endpoints
 ******************************************************************************/

export const ELEMENT_IDS = {
    // Grid elements
    GRID: "Grid",
    GRID_SORTING: "GridSorting",
    GRID_SENDING_REMITTANCES: "GridSendingRemittances",
    
    // Buttons
    BTN_EXPORT: "Export",
    BTN_EXPORT_KUNDUPEI: "ExportKundupei",
    BTN_EXPORT_GIRO: "ExportGiro",
    BTN_EXPORT_CSV: "ExportCSV",
    BTN_EXPORT_BACS: "ExportToBacs",
    BTN_EXPORT_NAB_BPAY: "ExportNabBpay",
    BTN_SORT: "SortColumns",
    BTN_CLEAR_SORT: "ClearSortColumns",
    BTN_REFRESH: "Refresh",
    BTN_MARK_AS_PAID: "MarkAsPaid",
    BTN_SEND_REMITTANCES: "SendRemittances",
    BTN_EXPORT_REPORT: "ExportBatchPaymentReport",
    BTN_NEXT_PAGE: "btnNextPage",
    BTN_LAST_PAGE: "btnLastPage",
    BTN_SUBMIT: "btnSumit",
    BTN_CANCEL_FEEDBACK: "btnCancelFeedback",
    BTN_PROMPT_OK_MARK_PAID: "btnPromptOkayMarkAsPaid",
    
    // Pagination
    CUSTOM_PAGER: "customPager",
    CURRENT_PAGE: "currentPage",
    
    // Spinners and loading
    SPINNER_GLOBAL: "spinnerGlobal",
    LOADING_PROCESS: "loadingProcess",
    
    // Display elements
    TOTAL: "total",
    SUCCESS_STATUS: "SuccessStatus",
    PROGRESS_STATUS: "progressStatusOnly",
    
    // Messages
    MSG_TRANSACTION_DATE: "messageTransactionDate",
    MSG_TRANSACTION_DATE_MP: "messageTransactionDateMp",
    
    // Feedback
    FEEDBACK_DESC: "feedbackDesc",
    FEEDBACK_DESC1: "feedbackDesc1",
    DIALOG_FEEDBACK_MODAL: "dialogFeedbackModal",
    
    // Dialogs/Containers
    DLG_CONTAINER: "dlgContainer",
    DLG_VIEW_ERROR_LIST: "dlgViewErrorList",
    DLG_FEEDBACK_MODAL: "dlgFeedbackModal",
    DLG_MARK_PAID_CONFIRMATION: "dlgMarkAsPaidConfirmation",
    DLG_MARK_PAID_ERROR_LIST: "dlgMarkAsPaidViewErrorList",
    DLG_CONTAINER_AFTER_EXPORT: "dlgContainerAfterExport",
    ERROR_DLG_CONTAINER: "errorDlgContainer",
    PROMPT_CONTAINER: "promptContainer",
    PROMPT_CONTAINER1: "promptContainer1",
    PROMPT_DLG_CONTAINER: "promptDlgContainer",
    PROMPT_DLG_CONTAINER_REPORT: "promptDlgContainerReport",
    PROMPT_DLG_CONTAINER_UPDATE_REF: "promptDlgContainerUpdateRef",
    PROMPT_DLG_CONTAINER_TX_DATE: "promptDlgContainerTransactionDate",
    PROMPT_DLG_CONTAINER_TX_DATE2: "promptDlgContainerTransactionDate2",
    PROMPT_DLG_PROGRESS_CONTAINER: "promptDlgProgressContainer",
    PROMPT_DLG_PROGRESS_CONTAINER_REPORT: "promptDlgProgressContainerReport",
    PROMPT_DLG_SENDING_REMITTANCE_PROGRESS: "promptDlgContainerSendingRemittanceProgress",
    PROMPT_CONTAINER_ABA: "promptContainerForABA",
    PROMPT_CONTAINER_MORE_INFO_ABA: "promptContainerMoreInfoForABA",
    SHARED_EXPORT_CONTAINER: "sharedExportContainer",
    SHARED_EXPORT_ABA_CONTAINER: "sharedExportABAContainer",
    SHARED_ERROR_LIST_CONTAINER: "sharedErrorListContainer",
    PROMPT_CONTAINER_MARK_PAID: "promptContainerForMarkAsPaid",
    PROMPT_CONTAINER_EXPIRE_SUBS: "promptContainerExpireSubscriptions",
    PROMPT_CONTAINER_WELCOME_SUBS: "promptContainerWelcomeSubscriptions",
    PROMPT_CONTAINER_ACTIVATE_SUBS: "promptContainerActivateSubscriptions",
    
    // Resend Remittances elements
    RESEND_DLG_CONTAINER: "resendRemittancesDlgContainer",
    RESEND_DIALOG: "resendRemittancesDialog",
    RESEND_START_DATE: "resendStartDate",
    RESEND_END_DATE: "resendEndDate",
    RESEND_LOADING: "resendLoadingIndicator",
    RESEND_RESULTS_CONTAINER: "resendResultsContainer",
    RESEND_NO_RESULTS: "resendNoResults",
    RESEND_INVOICES_LIST: "resendInvoicesList",
    RESEND_SELECT_ALL: "resendSelectAll",
    RESEND_SELECTED_COUNT: "resendSelectedCount",
    RESEND_PROGRESS_CONTAINER: "resendProgressContainer",
    RESEND_PROGRESS_MESSAGE: "resendProgressMessage",
    BTN_RESEND_CANCEL: "btnResendRemittancesCancel",
    BTN_RESEND_SEND: "btnResendRemittancesSend",
    
    // Re-run Report elements
    RERUN_DLG_CONTAINER: "reRunReportDlgContainer",
    RERUN_DIALOG: "reRunReportDialog",
    RERUN_START_DATE: "reRunStartDate",
    RERUN_END_DATE: "reRunEndDate",
    RERUN_LOADING: "reRunLoadingIndicator",
    RERUN_RESULTS_CONTAINER: "reRunResultsContainer",
    RERUN_NO_RESULTS: "reRunNoResults",
    RERUN_INVOICES_LIST: "reRunInvoicesList",
    RERUN_SELECT_ALL: "reRunSelectAll",
    RERUN_SELECTED_COUNT: "reRunSelectedCount",
    RERUN_PROGRESS_CONTAINER: "reRunProgressContainer",
    RERUN_PROGRESS_MESSAGE: "reRunProgressMessage",
    RERUN_DOWNLOAD_CONTAINER: "reRunDownloadContainer",
    RERUN_DOWNLOAD_PDF: "reRunDownloadPDF",
    RERUN_DOWNLOAD_CSV: "reRunDownloadCSV",
    BTN_RERUN_CANCEL: "btnReRunReportCancel",
    BTN_RERUN_GENERATE: "btnReRunReportGenerate",
    
    // Steps
    STEP1: "step1",
    STEP2: "step2",
    
    // Missing Data Modal elements
    MISSING_DATA_DLG_CONTAINER: "missingDataDlgContainer",
    MISSING_DATA_DIALOG: "missingDataDialog",
    MISSING_DATA_CONTACT_NAME: "missingDataContactName",
    MISSING_DATA_EMAIL: "missingDataEmail",
    MISSING_DATA_BANK_ACCOUNT_NUMBER: "missingDataBankAccountNumber",
    MISSING_DATA_ERROR_BOX: "missingDataErrorBox",
    MISSING_DATA_ERROR_MESSAGE: "missingDataErrorMessage",
    BTN_MISSING_DATA_CANCEL: "btnMissingDataCancel",
    BTN_MISSING_DATA_SAVE: "btnMissingDataSave"
};

export const STORAGE_KEYS = {
    SELECTED_DATA: "selectedData",
    SELECTED_DATA_FOR_REMITTANCE: "selectedDataForeRemittance"
};

export const API_ENDPOINTS = {
    // Core data endpoints
    FILTER_BILLS: "/Xero/FilterBills",
    FILTER_BILLS_SELECTED: "/Xero/FilterBillsSelected/",
    MARK_BILLS_PAID: "/Xero/MarkBillsAsPaid",
    CHECK_CONNECTED: "/Xero/CheckIfConnectedToXero/",
    GET_BANK_ACCOUNT_TYPES: "/Xero/GetBankAccountTypes",
    MARK_PAID_FORMAT_CHECK: "/Xero/MarkAsPaidFormatChecking",
    
    // Export endpoints - ABA (Australia)
    EXPORT_ABA_FORMAT_CHECK: "/Xero/ExportToAbaFormatChecking",
    EXPORT_ABA_FORMAT: "/Xero/ExportToAbaFormat",
    
    // Export endpoints - Kundupei (Singapore)
    EXPORT_KUNDUPEI: "/Xero/ExportKundupeiFormat",
    
    // Export endpoints - GIRO (Singapore)
    EXPORT_GIRO: "/Xero/ExportGiro",
    
    // Export endpoints - NZ
    EXPORT_NZ_FORMAT_CHECK: "/Xero/ExportToNZFormatChecking",
    EXPORT_NZ_CSV: "/Xero/ExportToNZCSVFormat",
    EXPORT_NZ_AFIV: "/Xero/ExportToNZAFIVFormat",
    EXPORT_NZ: "/Xero/ExportNZFormat",
    
    // Export endpoints - BACS (UK)
    EXPORT_BACS: "/Xero/ExportToBacsFormat",
    
    // Export endpoints - NAB BPAY (Australia)
    EXPORT_NAB_BPAY: "/Xero/ExportToNabBpayFormat",
    
    // Export endpoints - CBA BPAY (Australia)
    EXPORT_CBA_BPAY: "/Xero/ExportToCbaBpayFormat",
    
    // Remittance endpoints
    SEND_REMITTANCE: "/Xero/SendRemittanceAdviceV2",
    
    // Report endpoints
    UPDATE_PAYMENT_HISTORY: "/Xero/UpdatePaymentHistory",
    PROCESS_BATCH_REPORT: "/Xero/ProcessBatchReport1",
    PROCESS_BATCH_REPORT_CSV: "/Xero/ProcessBatchReportCSV",
    GENERATE_FINAL_REPORT: "/Xero/GenerateFinalReport",
    
    // Download endpoints
    DOWNLOAD_PDF: "/Xero/DownloadPDF/",
    DOWNLOAD_CSV: "/Xero/DownloadCSV/",
    DOWNLOAD_FILE: "/Xero/DownloadFile",
    
    // Feedback and logging
    SEND_FEEDBACK: "/Xero/SendFeebackBatchPay",
    LOG: "/Xero/Log",
    LOGGED_QUICK_TOUR: "/Xero/LoggedWhoClicksQuickTour",
    
    // Authorization
    ACTIVATE_TRIAL: "/Authorization/activateTrialPeriod/",
    CONTINUE_TRIAL: "/Authorization/ContinueTrialPeriod",
    
    // Error reporting
    ERROR_DISPLAY: "/ReportBug/ErrorDisplayJson/",
    ERROR_DISPLAY_REAUTH: "/ReportBug/ErrorDisplayJsonReauthorized/",
    
    // Contact update
    UPDATE_CONTACT_DETAILS: "/Xero/UpdateContactDetails",
    
    // Resend/Re-run features
    GET_PAID_INVOICES: "/Xero/GetPaidInvoicesForResend",
    RESEND_REMITTANCE: "/Xero/ResendRemittanceAdvice",
    REEXPORT_BATCH_REPORT: "/Xero/ReExportBatchPayReport",
    
    // Shared Organisation View
    GET_SHARED_GROUP_BILLS: "/Xero/GetSharedGroupBills",
    GET_BANK_ACCOUNTS_FOR_ORGS: "/Xero/GetBankAccountsForOrganisations",
    EXPORT_SHARED_GROUP: "/Xero/ExportSharedGroup",
    GENERATE_SHARED_BATCH_REPORT: "/Xero/GenerateSharedBatchReport",
    MARK_BILLS_AS_PAID_SHARED: "/Xero/MarkBillsAsPaidShared",

    // Page navigation
    BATCH_PAYMENTS: "/Xero/BatchPayments",
    HOME_INDEX: "/Home/Index"
};

export const PAGE_SIZES = [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];
export const DEFAULT_PAGE_SIZE = 500;
